import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { LoginModule } from "../login/login.module";
import { AthleteProfileModel } from "../athleteprofile/athleteprofile.service";

@Injectable()
export abstract class ApiService {
  urlbackend = environment.backend;
  modelName: string;
  model: any;
  _headers: any;

  constructor(
    private http: HttpClient,
    _model: any,
  ) {
    this.model = _model;
  }
  mapListToModelList(list: Array<Object>) {
    list.forEach((item, index) => {
      list[index] = this.mapModel(item);
    });

    return list;
  }

  mapModel(objects: any) {
    return this.model.setdata(objects);
  }

  findById(id: number, populate: Array<string> = null) {
    return new Promise((resolve, reject) => {
      let url = this.urlbackend + "/api/" + this.modelName + "/" + id;

      if (populate) {
        url = url + "?populate=" + populate.join(", ");
      }

      this._headers = new HttpHeaders();
      this._headers.set("Content-Type", "application/json; charset=UTF-8");
      this._headers.set("Accept", "application/json");
      this._headers.set("Token", environment.backendAccessToken);

      this.http
        .get(url, { headers: this._headers })
        .pipe(map((res) => this.json(res)))
        .subscribe((res) => {
          if (res.error) {
            reject(res.error);
          } else {
            resolve(this.mapModel(res));
          }
        });
    });
  }

  find(populate: Array<string> = null) {
    return new Promise((resolve, reject) => {
      let url = this.urlbackend + "/api/" + this.modelName;

      if (populate) {
        url = url + "?populate=" + populate.join(", ");
      }

      this._headers = new HttpHeaders();
      this._headers.set("Content-Type", "application/json; charset=UTF-8");
      this._headers.set("Accept", "application/json");
      this._headers.set("Token", environment.backendAccessToken);

      this.http
        .get(url, { headers: this._headers })
        .pipe(map((res) => this.json(res)))
        .subscribe((res) => {
          if (res.error) {
            reject(res.error);
          } else {
            resolve(this.mapListToModelList(res));
          }
        });
    });
  }

  upsert(model: any) {
    return new Promise((resolve, reject) => {
      let url = this.urlbackend + "/api/" + this.modelName;

      this._headers = new HttpHeaders();
      this._headers.set("Content-Type", "application/json; charset=UTF-8");
      this._headers.set("Accept", "application/json");
      this._headers.set("Token", environment.backendAccessToken);

      this.http
        .put(url, JSON.stringify(model), { headers: this._headers })
        .pipe(map((res) => this.json(res)))
        .subscribe((res) => {
          console.log(res);
          if (res.error) {
            reject(res.error);
          } else {
            resolve(this.mapModel(res));
          }
        });
    });
  }
  async login_API(username: string, password: string): Promise<LoginModule> {
    return new Promise<LoginModule>((resolve, reject) => {
      let url = this.urlbackend + "/api/" + this.modelName;

      this._headers = new HttpHeaders();
      this._headers.set("Content-Type", "application/json; charset=UTF-8");
      this._headers.set("Accept", "application/json");

      this.http
        .post(
          url,
          JSON.stringify({
            username: username,
            password: password,
            token: environment.backendAccessToken,
          }),
          { headers: this._headers },
        )
        .pipe(
          map((res) => {
            this.mapModel(res);
          }),
        )
        .subscribe((res) => {
          if (this.model) {
            resolve(this.model);
          } else {
            this.model = new LoginModule();
            this.model.setdata({ message: "Failed." });
            reject(this.model);
          }
        });
    });
  }
  athlete_profile(input: string): Promise<AthleteProfileModel> {
    return new Promise<AthleteProfileModel>((resolve, reject) => {
      let url = this.urlbackend + "/api/" + this.modelName;
      this._headers = new HttpHeaders();
      this._headers.set("Content-Type", "application/json; charset=UTF-8");
      this._headers.set("Accept", "application/json");
      this.http
        .post(
          url,
          JSON.stringify({
            input: input,
            token: environment.backendAccessToken,
          }),
          { headers: this._headers },
        )
        .pipe(
          map((res) => {
            this.mapModel(res);
          }),
        )
        .subscribe((res) => {
          if (this.model) {
            resolve(this.model);
          } else {
            this.model = new LoginModule();
            this.model.setdata({ message: "Failed." });
            reject(this.model);
          }
        });
    });
  }
  athlete_profile_By_Id(id: Number): Promise<AthleteProfileModel> {
    return new Promise<AthleteProfileModel>((resolve, reject) => {
      let url = this.urlbackend + "/api/" + this.modelName;
      this._headers = new HttpHeaders();
      this._headers.set("Content-Type", "application/json; charset=UTF-8");
      this._headers.set("Accept", "application/json");
      this.http
        .post(
          url,
          JSON.stringify({ id: id, token: environment.backendAccessToken }),
          { headers: this._headers },
        )
        .pipe(
          map((res) => {
            this.mapModel(res);
          }),
        )
        .subscribe((res) => {
          if (this.model) {
            resolve(this.model);
          } else {
            this.model = new LoginModule();
            this.model.setdata({ message: "Failed." });
            reject(this.model);
          }
        });
    });
  }
  create(model: any) {
    return new Promise((resolve, reject) => {
      let url = this.urlbackend + "/api/" + this.modelName;

      this._headers = new HttpHeaders();
      this._headers.set("Content-Type", "application/json; charset=UTF-8");
      this._headers.set("Accept", "application/json");
      this._headers.set("Token", environment.backendAccessToken);

      this.http
        .post(url, JSON.stringify(model), { headers: this._headers })
        .pipe(map((res) => this.json(res)))
        .subscribe((res) => {
          console.log(res);
          if (res.error) {
            reject(res.error);
          } else {
            resolve(this.mapModel(res));
          }
        });
    });
  }
  json(res: any) {
    if (typeof res._body === "string") {
      return JSON.parse(<string>res._body);
    }

    if (res._body instanceof ArrayBuffer) {
      return JSON.parse(res.text());
    }

    return res._body;
  }
}
